import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions, GridReadyEvent, RowDoubleClickedEvent, SelectionChangedEvent } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IBatchCreditList, ISeachTrip } from 'app/core/interfaces/posting.interface';
import { PostingService } from 'app/core/services/posting.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { getSelectNodeAfterFilter } from 'app/utils/helpers';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { IMyOptions } from 'mydatepicker';
import { DateModel } from 'app/pages/A2-utils/ParentClass/parent-class-date.model';
import { BatchStatusEnum } from 'app/core/enums/batch-status.enum';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';

@Component({
  selector: 'app-posting',
  templateUrl: './posting.component.html',
  styleUrls: ['./posting.component.scss'],
})
export class PostingComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('modalEditReservation') modalEditReservation: T2CardComponent;
  @ViewChild('modalChargeDetails') modalChargeDetails: T2CardComponent;
  @ViewChild('modalEditCredit') modalEditCredit: T2CardComponent;
  subscriptions: Subscription[] = [];
  gridData: IBatchCreditList[] = [];
  gridDataFilter: IBatchCreditList[] = [];
  gridOptions: GridOptions;
  arrayPayors: any[] = [];
  tab: 'credit' | 'autofill' | 'import' | 'preposting' = null;
  tabHeader: 'batchCredit' | 'batchHistory' = 'batchCredit';
  tabExceptions: 'readyPost' | 'exceptions' | 'denials' = 'readyPost';
  isEdit: boolean;
  reservationData: any;
  protected showRollBack= false;

  readyToPostCount = 0;
  denialsCount = 0;
  exceptionCount = 0;
  arraybatchinfoid = [];
  ptrDateBegin: DateModel;
  ptrDateEnd: DateModel;
  dateRangeExport: any;
  myRDPOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false
  };
  isPosting: boolean;
  titleCard = 'Manual Credit';
  isEditModal: boolean;
  isOpenAppRidersCreate: boolean;
  get arraybatchinfoidLength(): boolean {
    return !this.arraybatchinfoid.length;
  }

  get isTabBacthCredit(): boolean {
    return this.tabHeader === 'batchCredit';
  }

  get disabledButtonsControls(): boolean {
    return this.tabHeader === 'batchHistory' || this.isEdit;
  }

  constructor(
    private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    private Inject: Injector
  ) {
    super('app-posting', Inject);
    this.createGrid();
  }

  ngOnInit(): void {
    this.loadAllPostingBatchCredit();
    this.subscribeObservables();
    this.initDateRange();
    this.clearCount();
  }

  loadAllPostingBatchCredit(showHistory: boolean = false) {
    const body: { startdate: any, enddate: any, isposting: boolean } = {
      isposting: showHistory,
      startdate: this.ptrDateBegin,
      enddate: this.ptrDateEnd
    };

    this.t2LoadingService.show();
    this.subscriptions.push(
      this.postingService.getListPostingBatchCredit(body).subscribe(
        (resp: IBatchCreditList[]) => {
          this.t2LoadingService.hiden();
          if (resp) {
            this.gridData = resp;
            this.gridDataFilter = resp.filter(f => f.batchstatusid !== BatchStatusEnum.Reverted);

          }
        },
        (error) => {
          this.t2LoadingService.hiden();
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  subscribeObservables() {
    this.subscriptions.push(
      this.postingService.saveSubject$.subscribe((save: boolean) => {
        this.tabHeader = 'batchCredit';
        this.reload(save);
      })
    );

    this.subscriptions.push(
      this.postingService.openCreditModal.subscribe((open: boolean) => {
        if (open) {
          this.openModalCredit();
        } else {
          this.closeModalCredit();
        }
      })
    );

    this.subscriptions.push(
      this.postingService.countTabs$.subscribe((resp) => {
        if (resp !== null) {
          switch (resp.tab) {
            case 'readyPost':
            this.readyToPostCount = resp.count;
            break;
            case 'exceptions':
              this.exceptionCount = resp.count;
            break;
            case 'denials':
              this.denialsCount = resp.count;
            break;
          }
        }
      })
    );

    this.subscriptions.push(
      this.postingService.updateRowAmount$.subscribe({
        next: (res) => {
          if (res && res !== null) {
            if (this.gridOptions.api) {
              const row = this.gridOptions.api.getRowNode(res.batchInfoId.toString());
              row.setDataValue('totaltarget', res.totalAmount);
            }
          }
        },
        error: (error: any) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      })
    );

    this.subscriptions.push(
      this.postingService.dataModalReservation$.subscribe((resp) => {
        if (resp) {
          const tripData = Object.assign({}, resp);
          tripData.pnc = String(resp.pnc).slice(2);
          this.reservationData = tripData;
          this.modalEditReservation.open();
        }
      })
    );

    this.subscriptions.push(
      this.postingService.modalChargesDetails.subscribe((event) => {
        if (!event.isOpen) {
          this.modalChargeDetails.close();
          return;
        }
        this.modalChargeDetails.open();
      })
    );

    this.subscriptions.push(
      this.postingService.modeEditCredit$.subscribe((isEdit) => {
        if (isEdit) {
          isEdit.isEditMode ? this.modalEditCredit.open() : this.modalEditCredit.close();
        }
      })
    );
  }

  createGrid() {
    this.gridOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      getRowStyle: this.getRowStyleFn,
      columnDefs: [
        {
          colId: 'batchcreditid',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 60
        },
        {
          colId: 'batchinfoid',
          headerName: 'Batch #',
          field: 'batchinfoid',
          width: 100
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 260
        },
        {
          headerName: 'Check #',
          cellStyle: { 'text-align': 'end' },
          field: 'check',
          width: 190
        },
        {
          colId: 'totaltarget',
          headerName: 'Amount',
          field: 'totaltarget',
          width: 185,
          cellStyle: { 'text-align': 'end' },
          cellRenderer: (params) => {
            let decimal = 0;
            if (params.value) { decimal = params.value; }
            return new Intl.NumberFormat('en-US', { style: 'currency', minimumFractionDigits: 2, currency: 'USD' }).format(decimal);
          },
        },
        {
          headerName: 'Create Date / Hours',
          field: 'addedon',
          width: 260,
          hide: false,
          cellRenderer: (params) => {
            if (params && params.data.addedon) {
              return moment(params.data.addedon).format('MM-DD-YYYY HH:mm');
            }
          }
        },
        {
          headerName: 'Posted Date / Hours',
          field: 'modifiedon',
          width: 120,
          hide: true,
          cellRenderer: (params) => {
            if (params && params.data.modifiedon) {
              return moment(params.data.modifiedon).format('MM-DD-YYYY HH:mm');
            }
          }
        },
        {
          headerName: 'User',
          cellStyle: { 'text-align': 'start' },
          field: 'nameadminuser',
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event) {
          this.gridOptions.api.sizeColumnsToFit();
        }
      },
      onSelectionChanged: (event: SelectionChangedEvent) => {
        if (event) {
          this.onSelectionChanged();
        }
      },
      onRowDoubleClicked: (event: RowDoubleClickedEvent) => {
        if (event && event.data) {
          this.onRowDoublicked(event);
          if (event.data.includetripsclosed) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Attention',
              text: `This batch ${event.data.batchinfoid} contains trips that are currently closed`,
              type: 'error'
            });
          }
        }
      },
      getRowNodeId: (params: any) => {
        if (params) {
          return  params.batchinfoid;
        }
      }
    };
  }

  onRowDoublicked(event: RowDoubleClickedEvent) {
    if (this.tabHeader === 'batchHistory') {
      this.postingService.setEnableReadOnlyMode(true);
    } else {
      this.postingService.setEnableReadOnlyMode(false);
    }
    if (event) {
      this.readyToPostCount = 0;
      this.denialsCount = 0;
      this.exceptionCount = 0;
      this.isEdit = true;
      this.tab = 'credit';
      this.postingService.setBatchInfoId(event.data.batchinfoid);
    }
  }

  OnInitChangeTab(showColumn = true): void {
    if (showColumn) {
      this.ptrDateBegin = null;
      this.ptrDateEnd = null;
    }
    this.arraybatchinfoid = [];
    this.gridData = [];
    this.gridDataFilter = [];
    this.postingService.setBatchCreditListSubject(null);
    this.tab = null;
    this.isEdit = false;
    this.gridOptions.columnApi.setColumnVisible('batchcreditid', showColumn);
  }

  changeTabHeader(tab: 'batchCredit' | 'batchHistory'): void {
    this.tabHeader = tab;
    this.clearCount();

    let visibleColumns: string[];
    let hideColumns: string[];

    switch (tab) {
      case 'batchCredit':
        this.loadAllPostingBatchCredit();
        this.OnInitChangeTab();
        this.postingService.setEnableReadOnlyMode(false);

        visibleColumns = ['addedon'];
        hideColumns = ['modifiedon'];
        this.showRollBack = false;
        break;
      case 'batchHistory':
        visibleColumns = ['modifiedon'];
        hideColumns = ['addedon'];

        this.initDateRange();

        if (this.dateRangeExport !== null) {
          this.ptrDateBegin = this.formatDateRangeNgModel(this.dateRangeExport.beginDate).formattedOut;
          this.ptrDateEnd = this.formatDateRangeNgModel(this.dateRangeExport.endDate).formattedOut;
        }

        this.loadAllPostingBatchCredit(true);
        this.OnInitChangeTab(false);
        break;
    }

    this.toggleColumnsAgGrid(this.gridOptions, visibleColumns, hideColumns);
  }

  changeTabExceptions(tab: 'readyPost' | 'exceptions' | 'denials') {
    if (this.isEdit) {
      this.tabExceptions = tab;
      switch (tab) {
        case 'readyPost':
          this.postingService.setTabExceptions('readyPost');
        break;
        case 'exceptions':
          this.postingService.setTabExceptions('exceptions');
        break;
        case 'denials':
          this.postingService.setTabExceptions('denials');
        break;
      }
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'You do not have permissions to perform this action',
        type: 'error',
      });
    }
  }

  changeTab(tab: 'credit' | 'import' | 'autofill' | 'preposting') {
    if (!this.disabledButtonsControls) {
      this.tab = tab;
      this.postingService.setBatchCreditListSubject(null);
      this.postingService.setBatchInfoId(null);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'You do not have permissions to perform this action',
        type: 'error',
      });
    }
  }

  openModalCredit() {
    this.modalChargeDetails.open();
  }

  closeModalCredit() {
    if (this.modalChargeDetails.isOpen) {
      this.modalChargeDetails.close();
    }
  }

  reload(save: boolean) {
    this.clearCount();
    if (save) {
      this.loadAllPostingBatchCredit(false);
    }
    this.tab = null;
    this.isEdit = false;
  }

  setterCount(event: any): void {
    switch (event.tab) {
      case 'readyPost':
        this.readyToPostCount = event.count;
        break;
      case 'exceptions':
        this.denialsCount = event.count;
        break;
      case 'denials':
        this.exceptionCount = event.count;
        break;
      default:
        break;
    }
  }

  clearCount() {
    this.readyToPostCount = 0;
    this.denialsCount = 0;
    this.exceptionCount = 0;
  }

  get isBatchHistory(): boolean {
    return this.tabHeader === 'batchHistory';
  }

  onSelectionChanged(): void {
    const selectedRows = getSelectNodeAfterFilter(this.gridOptions);
    this.arraybatchinfoid = [];
    if (selectedRows && selectedRows.length) {
      selectedRows.forEach((row) => {
        if (row) {
          this.arraybatchinfoid.push(row.batchinfoid);
        }
      });
    }
  }

  deleteBatchList(): void {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Delete Selected Batch',
      text: 'Are you sure you want to delete this Batch list?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.t2LoadingService.show();
        this.subscriptions.push(
          this.postingService.deleteAllBatch(this.arraybatchinfoid)
          .subscribe({
            next: (res: any) => {
              this.t2LoadingService.hiden();
              this.bodyDetailsAlert(res);
            },
            error(err: any) {
              this.t2LoadingService.hiden();
              this.sweetAlertHelper.createCustomAlert({
                title: 'Error',
                text: err.message,
                type: 'error',
              });
            }
          })
        );
      }
    });
  }

  bodyDetailsAlert(response: any): any {
    const msgResponse = response.message;
    const batchDeleted = response.batchdeletedlist;
    const batchPosted = response.batchpostedlist;

    const iconoType: any = !batchDeleted.length ? 'error' : 'success';
    return this.sweetAlertHelper.createCustomAlert(
      {
        title: batchDeleted.length ? 'Success' : 'Error',
        html: ` <div class="container margin-t-10 height-250 scrollbar scrollbar-small">
                  <h3 style="${!batchDeleted.length ? 'color: red;' : 'color: black'}" >${msgResponse}</h3>
                  <h4>Selected Batch: </h4> ${this.arraybatchinfoid.length}

                  <h4 style="${!batchDeleted.length ? 'display: none' : 'color: black' }">Batch Deleted:</h4>
                  <div class="container scrollbar scrollbar-small"
                    style="${!batchDeleted.length ? 'display: none' : 'color: black' }">
                    ${batchDeleted.filter((item) => item).join('<br>')}
                  </div>

                  <h4 style="${batchDeleted.length ? 'display: none' : 'color: red' }" >
                    Batch not deleted because they are already posted:
                  </h4>
                  <div class="container height="auto" scrollbar scrollbar-small"
                      style="${batchDeleted.length ? 'display: none' : 'color: red' }">
                    ${ batchPosted.filter((item) => item).join('<br>') }
                  </div>
                </div>
                `,
        type: iconoType,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        cancelButtonColor: '#d33',
      }
    ).then(() => {
      this.postingService.reloadMainGrid(true);
      this.arraybatchinfoid = [];
    });
  }

  onDateExportSelectedRange(event: any): void {
    this.ptrDateBegin = this.formatDateRangeNgModel(event.beginDate).formattedOut;
    this.ptrDateEnd = this.formatDateRangeNgModel(event.endDate).formattedOut;
  }

  formatDateRangeNgModel(dateRange: { day: any, month: any, year: any }): { formattedOut: any } {
    const DAY_FORMAT = (dateRange.day < 10) ? `0${dateRange.day}` : dateRange.day;
    const MONTH_FORMAT = (dateRange.month < 10) ? `0${dateRange.month}` : dateRange.month;
    const FORMAT_BEGIN = `${MONTH_FORMAT}/${DAY_FORMAT}/${dateRange.year}`;
    return { formattedOut: FORMAT_BEGIN};
  }

  initDateRange(): void {
    const SUBTRACT_MONTH = moment().subtract(1, 'months').format('YYYY/DD/MM');
    const [ YEAR, DAY, MONTH ] = SUBTRACT_MONTH.split('/');
    const INIT = { year: Number(YEAR), month: Number(MONTH), day: Number(DAY) };
    const END = { year: moment().year(), month: (moment().month() + 1), day: moment().date() };
    this.setDateRange(INIT, END);
  }

  setDateRange(...args: any[]): void {
    const [ INIT_DATE, END_DATE ] = args;
    this.dateRangeExport = {
      beginDate: { year: INIT_DATE.year, month: INIT_DATE.month, day: INIT_DATE.day },
      endDate: { year: END_DATE.year, month: END_DATE.month, day: END_DATE.day }
    };
  }

  submitRunAction() {
    if (this.dateRangeExport !== null) {
      this.ptrDateBegin = this.formatDateRangeNgModel(this.dateRangeExport.beginDate).formattedOut;
      this.ptrDateEnd = this.formatDateRangeNgModel(this.dateRangeExport.endDate).formattedOut;
      this.loadAllPostingBatchCredit(true);
      this.OnInitChangeTab(false);
      this.clearCount();
      this.showRollBack = false;
    }
  }

  cancel(event: any) {
    if (!event.isOpen) {
      this.postingService.onOpenCreditModal(false);
    }
  }

  get nameLabelPost(): string {
    return this.tabHeader === 'batchCredit' ? 'Ready To Post' : 'Posted';
  }

  get isOpenRider(): string {
    return this.isOpenAppRidersCreate ? 'card-modal-w-100' : 'width-750';
  }

  get titleReservation(): string {
    if (this.reservationData) {
      return `Reservation #${this.reservationData.pnc}`;
    }
  }

  toggleColumnsAgGrid(configGrid: GridOptions, showColumns: string[], hideColumns: string[]): void {
    configGrid.columnApi.setColumnsVisible(showColumns, true);
    configGrid.columnApi.setColumnsVisible(hideColumns, false);
  }

  getRowStyleFn(params: any): any {
    const OBJ_STYLE_ROW = {
      'background-color': '#ffffff',
      color: '#000000',
      cursor: 'default',
    };

    if (params.data && params.data.batchstatusid === BatchStatusEnum.Reverted) {
      OBJ_STYLE_ROW['background-color'] = '#ffaba6';
      OBJ_STYLE_ROW['border'] = '1px solid rgba(255, 15, 0, 5)';
    }

    if (params.data && params.data.includetripsclosed) {
      OBJ_STYLE_ROW['background-color'] = '#ffb2b2';
      OBJ_STYLE_ROW['border'] = '1px solid #ff837b';
    }

    return OBJ_STYLE_ROW;
  }

  rollbackShow(): void {
    if (this.showRollBack) {
      this.gridOptions.api.setRowData(this.gridData);
    } else {
      this.gridOptions.api.setRowData(this.gridDataFilter);

      this.postingService.reloadMainGrid(false);
      this.postingService.setBatchCreditListSubject(null);
      this.postingService.setBatchInfoId(null);
      this.postingService.setArrayBatchcreditIds([]);
    }
    this.gridOptions.api.refreshView();
  }

  onCloseModalCredit(event): void {
    if (!event.isOpen) {
      this.postingService.modeEditCreditSubject.next(null);
    }
  }

  ngOnDestroy() {
    this.postingService.clearAllBhSubjects();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}

export const enum creditTypesEnum {
  payment = 1,
  contractual = 3,
  refund = 4,
  denials = 6,
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/posting/posting.component.ts